import { Alert, Icon, Snackbar as MuiSnackbar } from '@mui/material'
import useSnackbarStore from 'hooks/useSnackbarStore'

const Snackbar: React.FC = () => {
  const { snackbar, closeSnackbar } = useSnackbarStore()

  return (
    <MuiSnackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={snackbar.open}
      onClose={closeSnackbar}
      action={
        snackbar.showCloseIcon ? (
          <Icon className="cursor-pointer" onClick={closeSnackbar}>
            clear
          </Icon>
        ) : null
      }>
      <Alert severity={snackbar.type} onClose={snackbar.showCloseIcon ? closeSnackbar : undefined}>
        {snackbar.message}
      </Alert>
    </MuiSnackbar>
  )
}

export default Snackbar
